import React, { useEffect, useState } from 'react';
import Input from '../../../shared/components/Input/Input';
import Dialog from '../../../shared/components/Dialog/Dialog';
import { getRHUserValue } from '../utils/rhFormatters';
import { hasRHValidationErrors, validateRHProfile } from '../utils/rhValidation';

const buildForm = (user = {}) => ({
  firstName: getRHUserValue(user, 'firstName', 'first_name'), lastName: getRHUserValue(user, 'lastName', 'last_name'),
  birthDate: getRHUserValue(user, 'birthDate', 'birth_date'), email: getRHUserValue(user, 'email'), phone: getRHUserValue(user, 'phone'),
  address: getRHUserValue(user, 'address'), postalCode: getRHUserValue(user, 'postalCode', 'postal_code'), city: getRHUserValue(user, 'city'), country: getRHUserValue(user, 'country'),
  emergencyLastName: getRHUserValue(user, 'emergencyLastName', 'contactLastName', 'contact_last_name'), emergencyFirstName: getRHUserValue(user, 'emergencyFirstName', 'contactFirstName', 'contact_first_name'),
  emergencyRelationship: getRHUserValue(user, 'emergencyRelationship', 'contactRelationship'), emergencyPhone: getRHUserValue(user, 'emergencyPhone', 'contactPhone', 'contact_phone'),
});

function RHProfileEditDialog({ open, user, loading = false, error = '', onClose, onSubmit }) {
  const [form, setForm] = useState(() => buildForm(user));
  const [errors, setErrors] = useState({});
  useEffect(() => { if (open) { setForm(buildForm(user)); setErrors({}); } }, [open, user]);
  const change = ({ target: { name, value } }) => { setForm((current) => ({ ...current, [name]: value })); setErrors((current) => ({ ...current, [name]: undefined })); };
  const submit = () => { const nextErrors = validateRHProfile(form); setErrors(nextErrors); if (!hasRHValidationErrors(nextErrors)) onSubmit?.(form); };

  return (
    <Dialog open={open} onClose={onClose} onSubmit={submit} title="Modifier mon profil" submitLabel="Enregistrer" loading={loading} size="large">
      {error && <p className="rh-form-error" role="alert">{error}</p>}
      <div className="rh-dialog-grid">
        <Input fullWidth required label="Prénom" name="firstName" value={form.firstName} onChange={change} error={errors.firstName} />
        <Input fullWidth required label="Nom" name="lastName" value={form.lastName} onChange={change} error={errors.lastName} />
        <Input fullWidth label="Date de naissance" type="date" name="birthDate" value={form.birthDate} onChange={change} />
        <Input fullWidth label="E-mail personnel" type="email" name="email" value={form.email} onChange={change} error={errors.email} />
        <Input fullWidth label="Téléphone" name="phone" value={form.phone} onChange={change} />
        <Input fullWidth label="Adresse" name="address" value={form.address} onChange={change} />
        <Input fullWidth label="Code postal" name="postalCode" value={form.postalCode} onChange={change} />
        <Input fullWidth label="Ville" name="city" value={form.city} onChange={change} />
        <Input fullWidth label="Pays" name="country" value={form.country} onChange={change} />
      </div>
      <h3 className="rh-dialog-subtitle">Contact d’urgence</h3>
      <div className="rh-dialog-grid">
        <Input fullWidth label="Prénom" name="emergencyFirstName" value={form.emergencyFirstName} onChange={change} />
        <Input fullWidth label="Nom" name="emergencyLastName" value={form.emergencyLastName} onChange={change} />
        <Input fullWidth label="Lien avec le collaborateur" name="emergencyRelationship" value={form.emergencyRelationship} onChange={change} />
        <Input fullWidth label="Téléphone" name="emergencyPhone" value={form.emergencyPhone} onChange={change} />
      </div>
    </Dialog>
  );
}

export default RHProfileEditDialog;
